import './Text.css';
import React, { useState } from 'react';


export function Shoelaces() {
    const [FvgfAVej8] = useState('Fv-gf-AVej8')
  return (
    <div class="body">
      <div class="row">


<iframe  allow="fullscreen *"
frameborder="0"
        title='Freedom School'
        
        src={`https://youtube.com/embed/${FvgfAVej8}?autoplay=0`}>
</iframe>
    
    </div></div>

  );
}
